var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "position-relative" }, [
    _vm.isLoggedIn
      ? _c("div", { staticClass: "dropdown" }, [
          _vm.showLogin
            ? _c(
                "a",
                {
                  staticClass: "nav-link",
                  attrs: {
                    "data-testing": "login-select",
                    href: _vm.$ceres.urls.myAccount,
                    "aria-label": _vm.$translate(
                      "Ceres::Template.loginMyAccount"
                    )
                  }
                },
                [
                  _c("i", {
                    staticClass: "fa fa-user mr-1",
                    attrs: { "aria-hidden": "true" }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "d-none d-sm-inline" }, [
                    _vm._v(
                      _vm._s(_vm.$translate("Ceres::Template.loginMyAccount"))
                    )
                  ])
                ]
              )
            : _vm._e()
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.isLoggedIn
      ? _c("div", [
          _vm.showLogin
            ? _c(
                "a",
                {
                  staticClass: "nav-link",
                  attrs: {
                    "data-testing": "login-select",
                    href: _vm.isLogin ? "javascript:void(0)" : "#login",
                    "data-toggle": _vm.isLogin ? false : "modal",
                    "aria-label": _vm.$translate("Ceres::Template.login")
                  },
                  on: {
                    click: function($event) {
                      _vm.createLoginModal()
                      _vm.createRegisterModal()
                      _vm.unmarkInputFields()
                    }
                  }
                },
                [
                  _c("i", {
                    staticClass: "fa fa-user mr-1",
                    attrs: { "aria-hidden": "true" }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "d-none d-sm-inline" }, [
                    _vm._v(_vm._s(_vm.$translate("Ceres::Template.login")))
                  ])
                ]
              )
            : _vm._e()
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }